import * as React from 'react';

import { useVisibilityTracker } from '@coursera/event-pulse/react';

import { ExternalCoachAction } from 'bundles/ai-coach-platform/components/patterns/chat/ExternalCoachAction';
import { useAiAssistanceExperimentData } from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import StyledCoachTriggerButtonWithAnimationOnMount from 'bundles/unified-common/components/coach-on-discovery/StyledCoachTriggerButtonWithAnimationOnMount';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';

const COACH_INTENTION_ROUTER_ACTION_ID = 'ROUTER';

const CoachButton = () => {
  const { setCoachOpen, setContextConfig } = useCoachState();

  const {
    isAiAssistanceEnabled,
    coachConfig,
    coachConfig: {
      config: { coachModeId, coachActionId },
    },
    promptPillLabel,
    message,
  } = useAiAssistanceExperimentData();

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker('view_button', {
    button: {
      name: 'coach_trigger_button',
      linkName: `${coachModeId}_${coachActionId}`.toLowerCase(),
    },
  });

  if (!isAiAssistanceEnabled) {
    return null;
  }

  return (
    <div ref={visibilityTrackingRef}>
      <ExternalCoachAction
        size="small"
        key="coach"
        variant="secondary"
        customCoachTriggerButton={StyledCoachTriggerButtonWithAnimationOnMount}
        enableTextStreaming={true}
        enableLoggedOutMode={true}
        newSessionOnClick={false}
        onClick={() => {
          setContextConfig({
            ...coachConfig,
            config: {
              ...coachConfig.config,
              coachActionId: COACH_INTENTION_ROUTER_ACTION_ID,
            },
          });
          setCoachOpen(true);
        }}
        label={promptPillLabel}
        message={message}
        {...coachConfig}
      />
    </div>
  );
};

export default CoachButton;
